import React, { useEffect, useRef, useState } from 'react'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'
import s from './UniversityGalleryCarousel.module.scss'

const SLIDE_WIDTH = 218
const SLIDE_GAP = 10

export default function UniversityGalleryCarousel({ gallery = [] }) {
	const [currentIndex, setCurrentIndex] = useState(0)
	const [isVisible, setIsVisible] = useState(false)
	const [items, setItems] = useState(() =>
		(Array.isArray(gallery) ? gallery : []).filter(img => img?.s3_link),
	)
	const rootRef = useRef(null)
	const timerRef = useRef(null)

	useEffect(() => {
		setItems((Array.isArray(gallery) ? gallery : []).filter(img => img?.s3_link))
		setCurrentIndex(0)
	}, [gallery])

	useEffect(() => {
		const node = rootRef.current
		if (!node) return undefined
		const observer = new IntersectionObserver(
			([entry]) => setIsVisible(entry.isIntersecting),
			{ threshold: 0.4 },
		)
		observer.observe(node)
		return () => observer.disconnect()
	}, [])

	useEffect(() => {
		if (!isVisible || items.length < 2) {
			clearInterval(timerRef.current)
			return undefined
		}
		timerRef.current = setInterval(() => {
			setCurrentIndex(prev => (prev + 1) % items.length)
		}, 2000)
		return () => clearInterval(timerRef.current)
	}, [isVisible, items.length])

	if (!items.length) return null

	return (
		<div className={s.slider} ref={rootRef}>
			<div className={s.viewport}>
				<div
					className={s.track}
					style={{
						transform: `translateX(-${currentIndex * (SLIDE_WIDTH + SLIDE_GAP)}px)`,
					}}
				>
					{items.map((img, index) => (
						<GalleryItem
							key={`${img.s3_link}-${index}`}
							link={img.s3_link}
							index={index}
							onError={() => {
								setItems(prev => prev.filter((_, i) => i !== index))
								setCurrentIndex(0)
							}}
						/>
					))}
				</div>
			</div>
		</div>
	)
}

function GalleryItem({ link, index, onError }) {
	const [loaded, setLoaded] = useState(false)

	return (
		<div className={s.item}>
			<img
				src={link}
				alt={`Campus ${index + 1}`}
				onLoad={() => setLoaded(true)}
				onError={onError}
				style={{ display: loaded ? 'block' : 'none' }}
			/>
			{!loaded ? (
				<div className={s.loader}>
					<LoaderImg />
				</div>
			) : null}
		</div>
	)
}
